import _ from "lodash";
import React, { useState } from "react";

// Design System
import { EmptyState } from "@toddle-edu/ds-web";
import { LEIllustraton } from "@toddle-edu/ds-theme";

// External
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";

// Internal
import LEPreviewV2 from "AppComponents/LEPreviewV2";
import LeFeed from "AppComponents/LeFeed";
import I18nHOC from "UIComponents/I18nHOC";
import WorksheetPreview from "Worksheet/components/WorksheetPreview";

// Scss
import classes from "./LESelection.scss";
import { LE_FEED_STYLES } from "UnitPlans/modules/Utils";

const LESelection = props => {
  const {
    t,
    selectedItems,
    setSelectedItems,
    portalType,
    updateItems,
    groupType,
    testId = "unitPlan",
    isMultiSelect = false,
  } = props;

  const [worksheetItem, setWorksheetItem] = useState(null);
  const showLEPreview = _.get(selectedItems, "showLEPreview", true);

  const updateSelectedLeIds = ids => {
    updateItems({ key: "selectedAssessments", value: ids });
    setSelectedItems(prev => {
      return {
        ...prev,
        selectedAssessmentIds: ids,
        showLEPreview: true,
      };
    });
  };

  const updateAssessmentId = id => {
    updateItems({ key: "selectedAssessments", value: [id] });
    setSelectedItems(prev => {
      return {
        ...prev,
        selectedAssessmentId: id,
      };
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <LeFeed
          unitPlanId={selectedItems.unitPlan.id}
          portalType={portalType}
          assessmentId={selectedItems.selectedAssessmentId}
          feedAsPosts={true}
          showHeaderText={false}
          curriculumType={_.get(
            selectedItems,
            "unitPlan.curriculumProgram.type",
            ""
          )}
          importFromLeLibrary={false}
          setAssessmentId={assessmentId => updateAssessmentId(assessmentId)}
          updateSelectedItems={ids => updateSelectedLeIds(ids)}
          selectedItems={selectedItems.selectedAssessmentIds}
          showCardWithStaffProfile={true}
          showCheckBox={selectedItems.isMultiSelect}
          testId={`${testId}-assessmentImportModal`}
          groupType={groupType}
          {...LE_FEED_STYLES}
          setWorksheetItem={setWorksheetItem}
          isMultiSelect={isMultiSelect}
        />
      </div>
      {showLEPreview ? (
        <div className={classes.rightContainer}>
          {!_.isEmpty(selectedItems.selectedAssessmentId) ? (
            groupType === "WORKSHEET" ? (
              <WorksheetPreview
                t={t}
                worksheetItem={worksheetItem}
                assessmentId={_.get(selectedItems, "selectedAssessmentId")}
                id={_.get(selectedItems, "unitPlan.id")}
                imageUrl={_.get(worksheetItem, "imageUrl", "")}
                isImportWorksheet={true}
                portalType={null}
              />
            ) : (
              <LEPreviewV2
                assessmentId={selectedItems.selectedAssessmentId}
                portalType={portalType}
              />
            )
          ) : (
            <div className={classes.emptyStateContainer}>
              <EmptyState
                illustration={LEIllustraton}
                size="small"
                subtitle={t(
                  groupType === "WORKSHEET"
                    ? "common:select_worksheet_to_preview"
                    : "common:select_to_preview"
                )}
              />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { currentStep } = ownProps;
  const isLibraryOrCommunity = _.includes(
    ["COMMUNITY_LE_SELECTION", "LE_LIBRARY_LE_SELECTION"],
    currentStep
  );
  return {
    courseId: state.teacher.selected_class.selected_course,
    curriculumType: _.get(state, "platform.currentCurriculumProgram.type", ""),
    isLibraryOrCommunity,
  };
};

export default compose(
  connect(mapStateToProps),
  I18nHOC({ resource: ["common"] })
)(LESelection);
